import {
  useGetAdminCompetitionItemReportMutation,
  useGetAdminCompetitionsReportMutation,
} from 'entities/competitions-b2b';
import { useEffect } from 'react';

/**
 * @description Хук для скачивания отчетов. Создает пустой элемент в DOM-дереве и имитирует нажатие пользователя на сформированную blob-ссылку
 * @param id {number}
 * @param title
 * @param flow
 * @example Вызывается неусловно (non-conditional); List - необязателдьный параметр, который заставляет работать хук по всем отчетам сразу
 * const download = useReportDownload(id, title, 'list');
 * download();
 */
const useReportDownload = (id: number | undefined, title: string): (() => void) => {
  const fn = !id ? useGetAdminCompetitionsReportMutation : useGetAdminCompetitionItemReportMutation;
  const [download, { data }] = fn();

  useEffect(() => {
    if (!data) return;

    const fakeUrl = URL.createObjectURL(data);

    const fakeElement = document.createElement('a');
    fakeElement.href = fakeUrl;
    fakeElement.download = `${title}.xlsx`;
    fakeElement.click();

    fakeElement.remove();
  }, [data, title]);

  return () => (download as (arg: { competition_id: number } | void) => void)(id ? { competition_id: id } : undefined);
};

export { useReportDownload };
